export default "__VITE_ASSET__BDnW6fOb__"